import { Progress, Text, Stack, Group } from '@mantine/core';
import { IconCheck, IconLoader } from '@tabler/icons-react';

export interface ProgressIndicatorProps {
  progress: number;
}

interface Stage {
  threshold: number;
  label: string;
}

const STAGES: Stage[] = [
  { threshold: 0, label: 'Przygotowanie...' },
  { threshold: 20, label: 'Przesyłanie pliku...' },
  { threshold: 40, label: 'Walidacja formatu CSV...' },
  { threshold: 60, label: 'Przetwarzanie danych...' },
  { threshold: 80, label: 'Oszacowanie brakujących miesięcy...' },
  { threshold: 95, label: 'Finalizacja...' },
  { threshold: 100, label: 'Import zakończony pomyślnie!' },
];

function getCurrentStage(progress: number): string {
  // Find the highest stage threshold that progress has reached
  for (let i = STAGES.length - 1; i >= 0; i--) {
    if (progress >= STAGES[i].threshold) {
      return STAGES[i].label;
    }
  }
  return STAGES[0].label;
}

export function ProgressIndicator({ progress }: ProgressIndicatorProps) {
  const currentStage = getCurrentStage(progress);
  const isComplete = progress >= 100;

  return (
    <Stack gap="xs">
      <Group justify="space-between" gap="xs">
        <Group gap="xs">
          {isComplete ? (
            <IconCheck size={18} color="var(--mantine-color-green-6)" />
          ) : (
            <IconLoader size={18} className="rotating-icon" />
          )}
          <Text size="sm" fw={500} c={isComplete ? 'green' : 'blue'}>
            {currentStage}
          </Text>
        </Group>
        <Text size="sm" c="dimmed">
          {Math.round(progress)}%
        </Text>
      </Group>

      <Progress
        value={progress}
        size="lg"
        radius="md"
        animated={!isComplete}
        color={isComplete ? 'green' : 'blue'}
        styles={{
          root: {
            backgroundColor: 'var(--mantine-color-gray-2)',
          },
        }}
      />

      <style>
        {`
          @keyframes rotate {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }

          .rotating-icon {
            animation: rotate 1s linear infinite;
          }
        `}
      </style>
    </Stack>
  );
}
